import { API } from "../packages/constants";
import { selectAccess } from "../modules/auth/selectors";
import { AppState } from "../store";

export const getAccessAuthorizationHeaders = (state: AppState) => ({
  [API.ACCESS_HEADER]: selectAccess(state).token,
});
